import { nextTick, ref } from 'vue';

// Charts are lazy-loaded when scrolled into view; printing forces all of them to render first
export const forceShowCharts = ref(false);

export async function printWithAllCharts() {
    forceShowCharts.value = true;
    await nextTick();
    // let Chart.js draw the newly mounted canvases before the print snapshot
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    window.print();
}
